module.exports = __webpack_public_path__ + "static/img/img_gzhj3_2x.1626db2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/aboutus/img/img_gzhj3_2x.jpg
// module id = TV5h
// module chunks = 0